"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const native_1 = require("@react-navigation/native");
const react_1 = __importStar(require("react"));
const typesConstants_1 = require("../../constants/typesConstants");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const colors_1 = __importDefault(require("../../styles/colors"));
const messageComponent_1 = __importDefault(require("../messageComponent/messageComponent"));
const schedulesList_1 = __importDefault(require("./schedulesList"));
const spinner_1 = __importDefault(require("../spinner/spinner"));
const SchedulesSlice_1 = require("../../features/schedules/SchedulesSlice");
const scheduleSlice_1 = require("../../features/schedules/scheduleSlice");
const OfficerScheduleTable = ({ officerId }) => {
    const dispatch = useAppDispatch_1.default();
    const { schedules, loadingStatus } = useAppSelector_1.default((state) => ({
        schedules: state.schedules.schedules,
        loadingStatus: state.schedules.loadingStatus,
    }));
    native_1.useFocusEffect(react_1.useCallback(() => {
        dispatch(SchedulesSlice_1.getOfficerSchedules({ officerId, page: 1 }));
    }, []));
    const navigateToSchedule = ({ scheduleId }) => {
        dispatch(scheduleSlice_1.getSchedule({ scheduleId }));
        dispatch(scheduleSlice_1.getScheduleCustomerData({ scheduleId }));
    };
    const getSchedulesPage = (page) => {
        dispatch(SchedulesSlice_1.resetSchedulesState());
        dispatch(SchedulesSlice_1.getOfficerSchedules({ officerId, page }));
    };
    if (loadingStatus === typesConstants_1.PENDING_STATUS) {
        return react_1.default.createElement(spinner_1.default, null);
    }
    if (loadingStatus === typesConstants_1.FAILED_STATUS) {
        return react_1.default.createElement(messageComponent_1.default, { message: "An error occurred.", color: colors_1.default.RED, icon: free_solid_svg_icons_1.faExclamationCircle });
    }
    return react_1.default.createElement(schedulesList_1.default, { schedules: schedules, onRowPress: navigateToSchedule, onPageChange: getSchedulesPage });
};
exports.default = OfficerScheduleTable;
